module.exports = __webpack_public_path__ + "img/screen.abd50ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medi-mass/screen.jpg
// module id = 615
// module chunks = 5